import { CURRENT_COUNTRY } from "utils/constants";

export const LANGUAGE_CART_ATTRIBUTE_KEY = "language";

export const getLanguageCode = (language) => {
	const countryCode = CURRENT_COUNTRY === "ch" ? "de" : CURRENT_COUNTRY;
	const langCode = language === "default" ? countryCode : language;
	return langCode;
};

export const getLanguageCartAttributes = (languageCode) => {
	const value = String(languageCode || "").trim().toLowerCase();
	if (!value) return [];
	return [{ key: LANGUAGE_CART_ATTRIBUTE_KEY, value }];
};